<template>
    <div class="modal" id="mutation_modal" tabindex="-1" aria-labelledby="mutation_modal" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content shadow-3">
                <div class="modal-header">
                    <h5 class="mb-1">
                        {{ $trans.get('__JSON__.Shift Mutations') }}
                    </h5>
                </div>
                <div class="modal-body" v-if="enrollment">
                    <table class="table" v-if="enrollment.mutations.length > 0">
                        <thead>
                        <tr>
                            <th>{{ $trans.get('__JSON__.Who') }}</th>
                            <th>{{ $trans.get('__JSON__.Minutes') }}</th>
                            <th>{{ $trans.get('__JSON__.Reason') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="enrollment.mutations.length === 0">
                            <th colspan="2" class="text-center">
                                <em>{{ $trans.get('__JSON__.No corrections made') }}</em>
                            </th>
                        </tr>
                        <tr v-for="record in enrollment.mutations" v-else>
                            <td>
                                <strong>{{ record.who }}</strong>
                                <span class="d-block text-small">{{ record.when }}</span>
                            </td>
                            <td>{{ $trans.get('__JSON__.:amount minutes', { amount: record.mutationHuman }) }}</td>
                            <td>
                                <p class="text-wrap">{{ record.reason }}</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-neutral" data-bs-dismiss="modal">
                        {{ $trans.get('__JSON__.Close') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MutationDetailsModal',
    props: {
        enrollment: {
            required: true,
            default: null,
        },
    },
}
</script>
